
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/manage/risk",
      function () {
        return require("private-next-pages/en/ir/manage/risk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/manage/risk"])
      });
    }
  